import { TouchTransition } from "react-dnd-multi-backend";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";

/**
 * Custom HTML5 -> Touch pipeline with safer touch defaults:
 * - delayTouchStart: press-and-hold before drag to avoid accidental scroll drags
 * - touchSlop: small move threshold before starting drag
 * - scrollAngleRanges: let mostly-vertical gestures scroll instead of dragging
 */
export const HTML5toTouchCustom = {
  backends: [
    {
      id: "html5",
      backend: HTML5Backend,
    },
    {
      id: "touch",
      backend: TouchBackend,
      options: {
        enableMouseEvents: true,
        delayTouchStart: 150,
        touchSlop: 8,
        ignoreContextMenu: true,
        scrollAngleRanges: [{ start: 60, end: 120, axis: "y" }],
      },
      preview: true,
      transition: TouchTransition,
    },
  ],
};
